export { default } from 'cccisd-game-zoou-coop0';
